import { Capacitor } from '@capacitor/core'

/**
 * Capacitor 네이티브 셸 초기화.
 * 웹(브라우저)에서는 아무것도 하지 않는다(플러그인 동적 import로 웹 번들 영향 최소화).
 */
export function isNative(): boolean {
  return Capacitor.isNativePlatform()
}

export async function initNative(): Promise<void> {
  if (!isNative()) return

  // 스플래시 숨김 — 웹뷰가 첫 프레임을 그린 뒤.
  try {
    const { SplashScreen } = await import('@capacitor/splash-screen')
    await SplashScreen.hide()
  } catch {
    // 플러그인 미탑재 환경 무시
  }

  // 상태바 — 검은 배경(앱 셸 상단 존)이므로 밝은(흰) 아이콘.
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar')
    await StatusBar.setStyle({ style: Style.Dark })
  } catch {
    // iOS/edge-to-edge 등에서 실패 가능 — 무시
  }

  // Android 하드웨어 뒤로가기 — 히스토리가 있으면 뒤로, 루트면 앱 종료.
  try {
    const { App } = await import('@capacitor/app')
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back()
      } else {
        App.exitApp()
      }
    })
  } catch {
    // 무시
  }
}
